import React, { FC } from 'react';

interface ISettlements {
  className: string;
}
const Settlements: FC<ISettlements> = (props) => (
  <svg
    {...props}
    width="16"
    height="13"
    viewBox="0 0 16 13"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_13751_664)">
      <path
        opacity="0.4"
        d="M13.6 2.4V9.6H7.59995C7.49386 9.6 7.39212 9.64214 7.31711 9.71716C7.24209 9.79217 7.19995 9.89391 7.19995 10V10.8C7.19995 11.3304 6.98924 11.8391 6.61416 12.2142C6.23909 12.5893 5.73038 12.8 5.19995 12.8C4.66952 12.8 4.16081 12.5893 3.78574 12.2142C3.41066 11.8391 3.19995 11.3304 3.19995 10.8V1.625C3.19995 1.19402 3.02875 0.780698 2.724 0.475951C2.41925 0.171205 2.00593 0 1.57495 0L11.2 0C11.8363 0.000661796 12.4463 0.253731 12.8963 0.703675C13.3462 1.15362 13.5993 1.76368 13.6 2.4Z"
        fill="#213F7D"
      />
      <path
        d="M1.6 0C1.17565 0 0.768687 0.168571 0.468629 0.468629C0.168571 0.768687 0 1.17565 0 1.6L0 2.8C0 2.90609 0.0421427 3.00783 0.117157 3.08284C0.192172 3.15786 0.293913 3.2 0.4 3.2H3.2V1.625C3.20005 1.19832 3.03228 0.788739 2.73292 0.484701C2.43356 0.180663 2.02663 0.00656431 1.6 0V0ZM4.8 12.8H5.2C5.13525 12.8 5.0715 12.7968 5.0085 12.7908C4.93975 12.7968 4.87025 12.8 4.8 12.8ZM15.6 9.6H7.6C7.49391 9.6 7.39217 9.64214 7.31716 9.71716C7.24214 9.79217 7.2 9.89391 7.2 10V10.8C7.2 11.3304 6.98929 11.8391 6.61421 12.2142C6.23914 12.5893 5.73043 12.8 5.2 12.8H13.2C13.5678 12.8 13.9321 12.7275 14.2719 12.5867C14.6117 12.4459 14.9204 12.2395 15.1804 11.9794C15.4405 11.7192 15.6467 11.4104 15.7873 11.0705C15.9279 10.7306 16.0002 10.3663 16 9.9985C15.9996 9.89267 15.9573 9.79132 15.8823 9.71663C15.8073 9.64194 15.7058 9.6 15.6 9.6Z"
        fill="#213F7D"
      />
    </g>
    <defs>
      <clipPath id="clip0_13751_664">
        <rect width="16" height="12.8" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default Settlements;
